import { useCallback } from 'react';
import type { BirthDatePickerSelectOption } from '../BirthDatePicker';

export const useIncludesFilter = () =>
  useCallback(
    (input: string, option?: BirthDatePickerSelectOption) =>
      Boolean(option?.label.toLowerCase().includes(input.toLowerCase())),
    [],
  );
